module.exports = __webpack_public_path__ + "img/search_message.750d025b.png";